import(/* webpackMode: "eager" */ "/app/app/(commerce)/checkout/payment/page.tsx");
